/* src/app/pages/investments/investments.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: flex;
  flex-direction: column;
  background: var(--cds-background-accent);
  padding: 32px 24px;
}
span {
  color: var(--cds-text-strong);
}
main {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.investments-header {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 10px;
}
.cards-grid {
  display: grid;
  grid-template-columns: 350px 1fr 1fr;
  gap: 24px;
  align-items: stretch;
}
.cards-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.card-item {
  min-height: 120px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.cds-card {
  padding: 0px 24px 24px 24px;
}
.cds-card .card-header .card-title {
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: var(--cds-text-strong);
}
.card-total-balance {
  justify-content: center;
}
.card-total-balance .card-value {
  font-weight: 600;
  font-size: 20px;
}
.card-fees {
  justify-content: center;
}
.card-fees .card-value {
  font-weight: 600;
  font-size: 20px;
}
.card-types .types-list {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex: 1;
}
.card-types .type-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  flex: 1;
}
.card-types .type-bar {
  width: 6px;
  height: 24px;
  border-radius: 3px;
  flex-shrink: 0;
}
.card-types .type-name-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.card-types .type-value-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.card-types .type-value-container i {
  flex-shrink: 0;
}
.card-types .type-value {
  font-weight: 600;
}
.card-institutions .institutions-list {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.card-institutions .institution-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.card-institutions .institution-bar {
  width: 6px;
  height: 24px;
  border-radius: 3px;
  flex-shrink: 0;
}
.card-institutions .institution-name {
  flex: 1;
  font-weight: 500;
}
.card-institutions .institution-value {
  font-weight: 600;
}
.tabs-container {
  margin-top: 14px;
  margin-bottom: 32px;
}
.list-end-indicator {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
:host ::ng-deep .table-section.variable-income-table .table-row {
  cursor: default;
}
/*# sourceMappingURL=investments.component.css.map */
